import React from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from 'components/atoms/Button';
import { EButtonSizes, EButtonVariants } from 'constants/Buttons';
import { ERouteLinks } from 'models/route';
import { IConversation } from 'models/application';
import {
  conversationTableColumns,
  mapConversationToDataSource,
} from 'pages/MyApplicationsPage/ApplicationDetailsPage/helpers';
import { StyledTable } from './styles';

const conversationData: IConversation[] = [
  {
    id: 'fefb2ec3-a829-4c69-aa07-9841b67f6c04',
    date: '2025-05-20',
    userName: 'Jack Black',
    comment:
      'Hello, your application has been approved. Please make a payment and upload the required documents.\n' +
      'Link to payment: <a target="_blank" href="https://www.licence.police.dr/payment/03948039483948320948">https://www.licence.police.dr/payment/03948039483948320948</a>',
  },
  {
    id: 'fefb2ec3-a829-4c69-aa07-9841b67f6c05',
    date: '2025-05-18',
    userName: 'Jack Black',
    comment: 'The appointment sets. Date: 2025-05-22, 13.00-14.00',
  },
  {
    id: 'fefb2ec3-a829-4c69-aa07-9841b67f6c06',
    date: '2025-05-13',
    userName: 'Jack Black',
    comment:
      'Hello, according licence procedure I would like to invite you to our office to verify your identity. Please, click on the link attached to this message and choose the convienient day and time for an appoitment. ' +
      'Link: <a target="_blank" href="https://www.licence.police.dr/calendar/03948039483948320948">https://www.licence.police.dr/calendar/03948039483948320948</a>',
  },
  {
    id: 'fefb2ec3-a829-4c69-aa07-9841b67f6c07',
    date: '2025-05-10',
    userName: 'Jack Black',
    comment:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.',
  },
  {
    id: 'fefb2ec3-a829-4c69-aa07-9841b67f6c08',
    date: '2025-05-07',
    userName: 'Jack Black',
    comment:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor.',
  },
];

const ConversationStep = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Grid
      item
      container
      xs={12}
      alignItems="center"
      columnGap="20px"
      justifyContent="flex-end"
    >
      <Grid item container xs={12} md={4} xl={3} mb={2}>
        <Button
          label={t('page.applicationDetails.conversation.button.add')}
          variant={EButtonVariants.contained}
          onClick={() => navigate(ERouteLinks.ApplicationDetails.replace(':id', '0'))}
          size={EButtonSizes.small}
          fullWidth
        />
      </Grid>
      <StyledTable
        loading={false}
        columns={conversationTableColumns()}
        dataSource={mapConversationToDataSource(conversationData)}
      />
    </Grid>
  );
};

export default ConversationStep;
